module.exports = __webpack_public_path__ + "assets/media/evening.75a4b336.mp3";